export default __webpack_public_path__ + "static/media/15.99bf47a2.png";